import { render, staticRenderFns } from "./DocViewer.vue?vue&type=template&id=174bdd01&"
import script from "./DocViewer.vue?vue&type=script&lang=js&"
export * from "./DocViewer.vue?vue&type=script&lang=js&"
import style0 from "./DocViewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports